import { render, staticRenderFns } from "./UserCorrectionDocument.vue?vue&type=template&id=97841cda&"
import script from "./UserCorrectionDocument.vue?vue&type=script&lang=js&"
export * from "./UserCorrectionDocument.vue?vue&type=script&lang=js&"
import style0 from "./UserCorrectionDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports